import {useEffect,useState} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import { Modalmail } from '../modules/permisoDenegado/modalemail/ModalEmail'
import { useAuth } from '../modules/auth'
const API_URL = process.env.REACT_APP_API_URL
type ID = undefined | null | number




const DemoModal = ( props:any ) => {
  /*********************************Constantes**************************************** */
  const{currentUser}= useAuth()
  const [ ID , setID]=useState<ID>(undefined)


  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  
 
  return (
    
    <>


      {props.id === null &&
      <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7 f-parafo'>
            <p className='f-titulo gradiente-texto fs-md'>Welcome to the CTX Dashboard!</p>
            <p className='text-marino'>Dear <strong className='text-pink'>{currentUser?.firstName} {currentUser?.lastName}</strong>,</p>
            <p className='text-marino'>You are currently in a demonstration environment of CTX. This environment is designed for you to explore the functionalities and features that our platform offers.</p>
            <p className='text-marino'>If you are ready to take your operations to the next level and make the most of CTX in a productive environment, we invite you to contact our company. We will be delighted to guide you through the transition process and provide you with all the support you need to ensure a successful experience.</p>
            <p className='text-marino'><strong>Thank you for choosing CTX !</strong></p>
           
           <br />
                <div className='col' style={{flex:1,margin:'0 10px'}}>
                      <button className='btn btn-light-marino f-parrafo' onClick={ () => setID(null)}>Contact Sales</button>
                  </div>
             {/* <div className='row' style={{display:'flex',justifyContent:'space-between'}}>
                  
                  <div className='col'  style={{flex:1,margin:'0 10px'}}>
                      <a className='btn btn-light-marino f-parrafo' href='https://www.figma.com/proto/pAzrWNUGkTTsdccu7wcA8v/CloudTransit-Xchange-(New)?page-id=3602%3A1285&type=design&node-id=3602-9464&viewport=-1348%2C419%2C0.07&t=gK2ueIF01Y4beJNs-1&scaling=min-zoom' target='_blank'>More Information</a>
                  </div>
      </div>*/}
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }   
            {ID !== undefined && <Modalmail setID={setID} id={ID} />}

    </>
  )
}
export {DemoModal}